import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

const yt = (u) => { const m = (u || "").match(/(?:youtu\.be\/|v=|shorts\/|embed\/)([\w-]{11})/); return m ? m[1] : null; };

export const MediaView = ({ m, testid }) => {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (m.kind !== "file") return undefined;
    let url;
    api.get(`/test-files/${m.file_id}`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => setErr(true));
    return () => url && URL.revokeObjectURL(url);
  }, [m.kind, m.file_id]);
  const box = { maxWidth: 320, width: "100%", border: "1px solid rgba(255,255,255,0.08)", background: "#000" };
  if (m.kind === "link") {
    const id = yt(m.url);
    if (id) return <iframe title={m.name || "vídeo"} src={`https://www.youtube.com/embed/${id}`} style={{ ...box, aspectRatio: "16/9" }} allowFullScreen data-testid={testid} />;
    if (m.media_type === "image") return <img src={m.url} alt={m.name || ""} style={box} data-testid={testid} />;
    return <a href={m.url} target="_blank" rel="noreferrer" style={{ color: "#f87171", fontSize: 13 }} data-testid={testid}>Ver vídeo</a>;
  }
  if (err) return <div style={{ fontSize: 12, color: "#737373" }}>No se pudo cargar el archivo</div>;
  if (!src) return <div style={{ fontSize: 12, color: "#737373" }}>Cargando…</div>;
  return m.media_type === "image" ? <img src={src} alt={m.name || ""} style={box} data-testid={testid} /> : <video src={src} controls style={box} data-testid={testid} />;
};

export const StepsView = ({ steps, testid = "test-steps" }) => (
  <ol style={{ margin: 0, paddingLeft: 22, listStyle: "decimal" }} data-testid={testid}>
    {steps.map((s, i) => (
      <li key={i} style={{ marginBottom: 12, fontSize: 14 }} data-testid={`${testid}-${i}`}>
        <div style={{ whiteSpace: "pre-wrap" }}>{s.text}</div>
        {s.media?.length > 0 && <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 6 }}>{s.media.map((m, j) => <MediaView key={j} m={m} testid={`${testid}-${i}-media-${j}`} />)}</div>}
      </li>
    ))}
  </ol>
);
